
import { Component, Prop } from 'vue-property-decorator'
import { AppInputMultipleImages } from '@/components'
import CommonForm from '@/mixins/CommonForm'
import { ImageInterface, InputRule, SizeRule } from '@/utils/image'
import { getInputRuleFor, getSizeRulesFor, ScreenshotSize } from '@/utils/screenshot'
import { appInfoEntity } from '@/models/models'

@Component({
    components: {
        AppInputMultipleImages,
    },
})
export default class DetailAppleScreenshotsForm extends CommonForm {
    @Prop() public value?: AppInfoEntity

    get appInfo(): AppInfoEntity {
        return this.value ?? appInfoEntity
    }

    get sizeRulesForSixDotFive(): SizeRule[] {
        return getSizeRulesFor(ScreenshotSize.IOS_SIX_DOT_FIVE)
    }

    get sizeRulesForFiveDotFive(): SizeRule[] {
        return getSizeRulesFor(ScreenshotSize.IOS_FIVE_DOT_FIVE)
    }

    get sizeRulesForTwelveDotNine(): SizeRule[] {
        return getSizeRulesFor(ScreenshotSize.IOS_TWELVE_DOT_NINE)
    }

    get inputRuleForSixDotFive(): InputRule {
        return getInputRuleFor(ScreenshotSize.IOS_SIX_DOT_FIVE)
    }

    get inputRuleForFiveDotFive(): InputRule {
        return getInputRuleFor(ScreenshotSize.IOS_FIVE_DOT_FIVE)
    }

    get inputRuleForTwelveDotNine(): InputRule {
        return getInputRuleFor(ScreenshotSize.IOS_TWELVE_DOT_NINE)
    }

    get oldImagesForSixDotFive(): Array<[number, ImageInterface]> {
        return this.getOldImagesFor(ScreenshotSize.IOS_SIX_DOT_FIVE)
    }

    get oldImagesForFiveDotFive(): Array<[number, ImageInterface]> {
        return this.getOldImagesFor(ScreenshotSize.IOS_FIVE_DOT_FIVE)
    }

    get oldImagesForTwelveDotNine(): Array<[number, ImageInterface]> {
        return this.getOldImagesFor(ScreenshotSize.IOS_TWELVE_DOT_NINE)
    }

    public imageSubmittedForTwelveDotNine(image: [number, ImageInterface]) {
        this.imageSubmittedFor(ScreenshotSize.IOS_TWELVE_DOT_NINE, image)
    }

    public imageSubmittedForSixDotFive(image: [number, ImageInterface]) {
        this.imageSubmittedFor(ScreenshotSize.IOS_SIX_DOT_FIVE, image)
    }

    public imageSubmittedForFiveDotFive(image: [number, ImageInterface]) {
        this.imageSubmittedFor(ScreenshotSize.IOS_FIVE_DOT_FIVE, image)
    }

    public imageRemovedForSixDotFive(image: [number, ImageInterface]) {
        this.imageRemovedFor(ScreenshotSize.IOS_SIX_DOT_FIVE, image)
    }

    public imageRemovedForFiveDotFive(image: [number, ImageInterface]) {
        this.imageRemovedFor(ScreenshotSize.IOS_FIVE_DOT_FIVE, image)
    }

    public imageRemovedForTwelveDotNine(image: [number, ImageInterface]) {
        this.imageRemovedFor(ScreenshotSize.IOS_TWELVE_DOT_NINE, image)
    }

    public getOldImagesFor(screenshotSize: ScreenshotSize): Array<[number, ImageInterface]> {
        return this.value?.customScreenshots?.filter((appScreenshot) => {
            return appScreenshot.size === screenshotSize
        })?.map((appScreenshot) => {
            return [appScreenshot.id, { imageURL: appScreenshot.url }]
        }) ?? []
    }

    public imageSubmittedFor(screenshotSize: ScreenshotSize, image: [number, ImageInterface]) {
        this.$store.commit(
            'detail/addScreenshotApp',
            { size: `${screenshotSize}[]`, image: image[1] },
        )

        const customScreenshots = this.appInfo.customScreenshots ?? []
        customScreenshots.push({ id: 0, url: image[1].imageURL, size: screenshotSize })

        this.appInfo.customScreenshots = customScreenshots
    }

    public imageRemovedFor(screenshotSize: ScreenshotSize, image: [number, ImageInterface]) {
        this.$store.commit(
            'detail/deleteScreenshotApp',
            { size: `${screenshotSize}[]`, image },
        )

        let customScreenshots = this.appInfo.customScreenshots ?? []

        customScreenshots = customScreenshots.filter((customScreenshot) => {
            return customScreenshot.url !== image[1].imageURL
        })

        this.appInfo.customScreenshots = customScreenshots
    }

}
